export default {
  token: (state) => state.app.token,
  siderType: (state) => state.app.siderType,
  auth: (state) => state.app.auth,
  products: (state) => state.app.products,
  role: (state) => state.user.role,
  staff: (state) => state.user.staff,
};
